import React from 'react';
import BtnGoogle from '../../../../../components/ButtonsRedesSign/BtnGoogle';
import BtnFB from '../../../../../components/ButtonsRedesSign/BtnFB';
import BtnEmail from '../../../../../components/ButtonsRedesSign/BtnEmail';

import "./signInBtns.scss"


const SignInBtns = () => {
    return (
        <>
            <div className="buttonsContainer">
                <BtnEmail linkTo='/usuario/email-sesion' />
                <BtnFB />
                <BtnGoogle />
            </div>
        </>

    );
}

export default SignInBtns;